module.exports = __webpack_public_path__ + "static/media/new-order.b0aa90c9.mp3";